export const APPLICATION_INFO = 'APPLICATION_INFO'
